import React, { useEffect } from 'react';
import { Route, Routes, useLocation, useSearchParams } from 'react-router-dom';
import { useAnalyticsContext, withAnalyticsContext } from '@melio/platform-analytics';

import { RouterComponentWrapper } from '@/hoc/routerComponentWrapper';
import { useActiveScreen } from '@/hooks/useActiveScreen';
import { APP_EVENTS, emitAppEvent } from '@/queries/event-emitter-query';
import { AddInstantBillScreen } from '@/screens/just-pay/AddInstantBill.screen';
import { AddInstantBillV2Screen } from '@/screens/just-pay/AddInstantBillV2.screen';
import { SchedulePaymentScreen } from '@/screens/schedule-payment/SchedulePayment.screen';
import { ActiveFlowEnum, ScreensEnum } from '@/store/app/app.types';

export const JustPayRoute = withAnalyticsContext(() => {
  useActiveScreen(ScreensEnum.schedulePayment, ActiveFlowEnum.schedulePayment);
  useAnalyticsContext({ globalProperties: { origin: 'JustPay' } });
  const { state } = useLocation();
  const { returnUrl } = (state as { returnUrl?: string }) || {};
  const [searchParams] = useSearchParams();

  const amount = searchParams.get('amount') ?? '';
  const vendorId = searchParams.get('vendorId') ?? '';
  const defaultValues = { billAmount: amount, vendorId };

  useEffect(() => {
    return () => {
      emitAppEvent(APP_EVENTS.SCHEDULE_PAYMENT_FLOW_CLOSED);
    };
  }, []);

  return (
    <Routes>
      <Route path="/new-payment/*" element={<AddInstantBillV2Screen defaultValues={defaultValues} />} />
      <Route path="/new" element={<AddInstantBillScreen defaultValues={defaultValues} />} />
      <Route
        path="/:id"
        element={
          <RouterComponentWrapper
            Component={SchedulePaymentScreen}
            componentProps={{
              billId: {
                _pathParam: 'id',
              },
              returnUrl,
            }}
          />
        }
      />
    </Routes>
  );
});
